import { render, staticRenderFns } from "./FooterLegalInfo.vue?vue&type=template&id=7e2c0d7b&scoped=true"
import script from "./FooterLegalInfo.vue?vue&type=script&lang=js"
export * from "./FooterLegalInfo.vue?vue&type=script&lang=js"
import style0 from "./FooterLegalInfo.vue?vue&type=style&index=0&id=7e2c0d7b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e2c0d7b",
  null
  
)

export default component.exports